module.exports = __webpack_public_path__ + "static/media/promo_intro_2.d2521ca7.png";